import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import PublicLeadsPreview from './components/PublicLeadsPreview';
import ValueFlow from './components/ValueFlow';

/** 首页主体（不含导航）。系统脉搏等暂无接口，本期不展示。 */
export function HomeSections() {
  return (
    <>
      <HeroSection />
      <FeatureGrid />
      <PublicLeadsPreview />
      <ValueFlow />
      <Footer />
    </>
  );
}

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HomeSections />
    </main>
  );
}
